import { updateFileIdsInMessage } from './updateFileIdsInMessage';
export const removeFileIdFromMessage = (fileId, message) => {
  return updateFileIdsInMessage(message, currentFileIds => currentFileIds.filter(id => id !== fileId));
};